<template>
  <div>
    <attachment-preview
      v-for="(attachment, i) in attachments"
      :key="attachment.id"
      :attachment="attachment"
      :class="{ 'mb-4': i !== attachments.length - 1 }"
      :dense="dense"
    >
      <template v-slot:action>
        <slot name="action" :attachment="attachment" />
      </template>
    </attachment-preview>
  </div>
</template>

<script setup lang="ts">
import type { Attachment } from '@quotetome/materials-api'
import AttachmentPreview from '@/components/attachments/attachment-preview.vue'

export interface Props {
  attachments: Attachment[]
  dense?: boolean
}

defineProps<Props>()
</script>
